'use client';

import { LoanInvestmentValues } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

interface Props {
  values: LoanInvestmentValues;
  onValuesChange: (field: keyof LoanInvestmentValues, value: number) => void;
  translations: ToolsTranslations['loanInvestment'];
}

export default function CalculatorInputs({ values, onValuesChange, translations }: Props) {
  const handleChange = (field: keyof LoanInvestmentValues) => (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value.replace(/\s/g, '').replace(/,/g, '.');
    const value = Number(raw);
    onValuesChange(field, isNaN(value) ? 0 : value);
  };

  const inputClass = "w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500";

  return (
    <div className="space-y-6">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">{translations.loanAmount}</label>
        <input type="text" value={values.loanAmount.toLocaleString('sv-SE')} onChange={handleChange('loanAmount')} className={inputClass} placeholder="0" />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">{translations.interestPercent}</label>
        <input type="text" value={values.interestPercent} onChange={handleChange('interestPercent')} className={inputClass} placeholder="0" />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">{translations.dividendYieldPercent}</label>
        <input type="text" value={values.dividendYieldPercent} onChange={handleChange('dividendYieldPercent')} className={inputClass} placeholder="0" />
      </div>
    </div>
  );
}


